<template>

    <div>        
        <div class="row justify-content-md-center">
            <!--<div class="col-md-5">
        <div class="form-group mb-2">
            <label><strong>CPF/CNPJ</strong></label>
            <input type="text" class="form-control" v-model="filter.cpf">
        </div>
    </div>
    <div class="col-md-2 text-center">
        <p class="mt-4">ou</p>
    </div>-->

            <div class="col-md-5">
                <div class="form-group">
                    <label><strong>Chave de Acesso</strong></label><span>&nbsp;</span> <i class="fa fa-question-circle" v-b-tooltip title="Procure sua escola"></i>
                    <input type="text" class="form-control" v-model="filter.codigoAcesso">
                </div>
            </div>

        </div>

        <div class="row mt-2">
            <div class="col-6 ">
                <button type="button" class="btn btn-light border-primary rounded-pill previous-button px-4" @click="sendBack()">Voltar</button>
            </div>
            <div class="col-6 text-right">
                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="buscarPorCodigoAcesso()">Continuar</button>
            </div>
        </div>
    </div>

</template>



<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    

    export default {
        name: 'cadastro-identificacao',
        mixins: [base],
        props: {
            model: Object
        },
        data: () => ({
            filter: {
                cpf: null,
                codigoAcesso: null
            }
        }),
        methods: {
            buscarPorCodigoAcesso() {
                this.showLoading()
                new Api('pessoacna/buscarporcodigoacesso').get(this.filter).then(result => {
                    this.defaultSuccessResult("Usuário encontrado. Agora vamos revisar seus dados!");
                    this.$emit('on-next', result.data);
                }, err => {
                    this.defaultErrorResult(err, true);
                })
            },
            sendBack() {
                this.$emit('on-back')
            }
        },

        mounted() {
            let _codigo = this.$route.query.codigo;
            if (_codigo) this.filter.codigoAcesso = _codigo;
        }
    };
</script>
